import * as React from "react";

import { IAlert } from "./classes/Alert";
import { IText } from "./classes/Text";

import { SessionStorage } from "./sessionStorage/SessionStorage";

export interface IUnifiedPublishingLiveAlertDetail {
  alert: IAlert;
  text: IText;
}

export const UnifiedPublishingLiveAlertDetail = (props: IUnifiedPublishingLiveAlertDetail) => {

  // Track whether the user has already seen this alert.
  const storageKey = "alertIDsAlreadySeen";
  let isFirstDisplayOfThisAlert = true;

  const alertIDsAlreadySeen = SessionStorage.getAlertIDsAlreadySeen();
  if (alertIDsAlreadySeen.indexOf(props.alert.alertId) !== -1) {
    isFirstDisplayOfThisAlert = false;
  }

  if (isFirstDisplayOfThisAlert) {
    alertIDsAlreadySeen.push(props.alert.alertId);
    SessionStorage.setAlertIDsAlreadySeen(alertIDsAlreadySeen);
  }

  let className = "A_alert";
  let showStar = false;
  if (isFirstDisplayOfThisAlert) {
    className += " A_new";
    showStar = true;
  }

  return (
    <div className={className}>
      <div className="A_title">
        {showStar &&
          <React.Fragment><span><em className="fa fa-star"></em> {props.text.new}</span>&nbsp;</React.Fragment>
        }
        {props.alert.title}</div>
      <div className="A_content" dangerouslySetInnerHTML={{ __html: `${props.alert.body}` }}></div>
    </div>
  );
};
